import { useEffect, useState } from "react";

import { useNavigate, useParams } from "react-router-dom";

import { PageContainer } from "@/features/ui";

import { SUPPLIER_MULTI_SELECT_ACTIONS } from "@/features/chart-of-account-preferences";
import { mapEntityTaxInformationToFormValues } from "@/features/entity-tax-information";
import { apiClient, getErrorMessage } from "@/features/shared";
import { SupplierForm } from "@/features/suppliers/supplier-form";
import { useSnackbar } from "@/features/ui";

import { Button } from "@mui/material";

export const EditSupplier = () => {
  const { supplierId } = useParams();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);
  const [defaultValues, setDefaultValues] = useState(null);

  useEffect(() => {
    const fetchSupplier = async () => {
      setIsLoading(true);
      try {
        const {
          data: { data },
        } = await apiClient.get(`suppliers/${supplierId}`, {
          params: {
            withSupplierCategory: true,
            withSupplierContacts: true,
            withSellerBankAccounts: true,
            withEntityTaxInformation: true,
            withPaymentTerm: true,
            withAccountingActionChartOfAccounts: true,
          },
        });

        setDefaultValues({
          name: data.name,
          code: data.code,
          telephoneNumber: data.telephoneNumber || null,
          phoneNumber: data.phoneNumber || null,
          whatsappNumber: data.whatsappNumber || null,
          email: data.email || null,
          fax: data.fax || null,
          website: data.website || null,
          country: data.country || null,
          province: data.province || null,
          city: data.city || null,
          address: data.address || null,
          postalCode: data.postalCode || null,
          type: data.type,
          defaultPaymentTerm: data.defaultPaymentTerm,
          supplierCategory: data.supplierCategory,
          supplierContacts: data.supplierContacts,
          sellerBankAccounts: data.sellerBankAccounts.map(
            (sellerBankAccount) => ({
              ...sellerBankAccount,
              bank: sellerBankAccount.bank,
            })
          ),
          ...mapEntityTaxInformationToFormValues(data.entityTaxInformation),
          accountingActionChartOfAccounts: (
            data.accountingActionChartOfAccounts ?? []
          ).reduce((acc, item) => {
            if (!item.chartOfAccount) return acc;
            if (SUPPLIER_MULTI_SELECT_ACTIONS.has(item.action)) {
              (acc[item.action] ??= []).push(item.chartOfAccount);
            } else {
              acc[item.action] = item.chartOfAccount;
            }
            return acc;
          }, {}),
        });
      } catch (error) {
        showSnackbar(
          getErrorMessage(error, "Gagal memperbarui pemasok")
        );
      } finally {
        setIsLoading(false);
      }
    };
    fetchSupplier();
  }, [supplierId, showSnackbar]);

  const handleSubmit = async (formData) => {
    try {
      await apiClient.put(`suppliers/${supplierId}`, formData);
      navigate(-1);
    } catch (error) {
      showSnackbar(
        getErrorMessage(error, "Gagal memperbarui pemasok")
      );
    }
  };

  return (
    <PageContainer
      maxWidth="xl"
      title="Ubah Pemasok"
      breadcrumbs={[
        { title: "Pemasok", path: "/procurement/suppliers" },
        { title: "Ubah" },
      ]}
    >
      <SupplierForm
        isLoading={isLoading}
        defaultValues={defaultValues}
        onSubmit={handleSubmit}
        renderActionButton={({ isSubmitting }) => (
          <Button
            type="submit"
            variant="contained"
            loading={isSubmitting}
          >
            Simpan
          </Button>
        )}
      />
    </PageContainer>
  );
};
